const initialState = {
  list: null,
  detail: null,
};

const popularPropertyReducer = (state = initialState, action) => {
  switch (action.type) {
    case "GET_ALL_POPULAR_PROPERTIES":
      return { ...state, list: action.data };
    case "ADD_POPULAR_PROPERTY":
      return { ...state };
    case "UPDATE_POPULAR_PROPERTY":
      return { ...state };
    case "DELETE_POPULAR_PROPERTY":
      return { ...state };
    default:
      return state;
  }
};

export default popularPropertyReducer;
